// extracted by mini-css-extract-plugin
export default {"Grid":"styles_Grid__DqBTw"};